import { stringify } from "query-string";
import { dataProvider } from "./provider";

export default dataProvider;

export * from "./utils";

export { stringify };
